var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "users-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg users",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "users") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,20.6a6.51,6.51,0,0,1,4.7-2H17.4a6.34,6.34,0,0,1,4.7,2,6.51,6.51,0,0,1,2,4.7V28a1.3,1.3,0,0,1-2.6,0V25.3a3.63,3.63,0,0,0-1.2-2.8,4,4,0,0,0-2.8-1.2H6.7a3.63,3.63,0,0,0-2.8,1.2,4,4,0,0,0-1.2,2.8V28a1.32,1.32,0,0,1-1.3,1.3A1.42,1.42,0,0,1,0,28V25.3A6.68,6.68,0,0,1,2,20.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5.3a4,4,0,1,0,4,4A4,4,0,0,0,12,5.3Zm-6.7,4A6.7,6.7,0,1,1,12,16,6.7,6.7,0,0,1,5.3,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4,19.8a1.43,1.43,0,0,1,1.6-1,6.74,6.74,0,0,1,5,6.5V28a1.3,1.3,0,0,1-2.6,0V25.3h0a4.07,4.07,0,0,0-.8-2.4,3.68,3.68,0,0,0-2.2-1.4A1.33,1.33,0,0,1,25.4,19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3.8a1.43,1.43,0,0,1,1.6-1,6.72,6.72,0,0,1,3.6,10.6,6.79,6.79,0,0,1-3.6,2.4,1.33,1.33,0,1,1-.6-2.6,4,4,0,0,0,2.2-1.4,4.31,4.31,0,0,0,0-5A3.68,3.68,0,0,0,21,5.4,1.32,1.32,0,0,1,20,3.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4d4b4a48119102c29347e9498812a5c2.svg";
export { ForwardRef as ReactComponent };